import React, {Component} from 'react';
import {Session, CreditNotesDetailsModal} from "../../components";
import {DISPATCH_ID, SERVICE_API, SERVICE_RESPONSE, VIEW_NAME, config} from "../../libs/utils/Const";
import {ApiClient} from "../../libs/apiClient/ApiClient";
import {connect} from "react-redux";
import moment from 'moment';
import $ from 'jquery';
import CurrencyFormat from 'react-currency-format';

const apiClient = ApiClient.getInstance();

require('datatables.net-bs4');

class creditNotesView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            order: {
                header: {},
                body: []
            },
        };
        this.table = null;
    }

    componentDidMount() {
        this.fillDataCreditNotes();
    }

    fillDataCreditNotes = () => {
        const {enableSpinner,data} = this.props;
        this.table = $('#tablaCreditNotes').DataTable({
            "paging": true,
            "info": false,
            "searching": false,
            "order": [[ 2, 'desc' ]],
            "language": {
                "lengthMenu": "Mostrar _MENU_ registros por página",
                "zeroRecords": "No se encontraron registros",
                "info": "Mostrando página _PAGE_ de _PAGES_",
                "infoEmpty": "No existen registros",
                "infoFiltered": "(filtrado de _MAX_ entradas)",
                "loadingRecords": "Buscando...",
                "processing": "Procesando...",
                "search": "Buscar:",
                "paginate": {
                    "first": "Primero",
                    "last": "Último",
                    "next": "Siguiente",
                    "previous": "Anterior"
                }
            }
        });
    }

    shouldComponentUpdate(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): boolean {
        if (this.props.orders != nextProps.orders) {
            this.table.destroy();
            this.table = null;
        }
        return true;
    }

    componentDidUpdate(): void {
        if (this.table == null) {
            this.fillDataCreditNotes();
        }
    }

    docChangeName(status) {
        let result = '';
        switch (status) {
            case 'O':
                result = "Abierto";
                break;
            case 'C':
                result = "Cerrado";
                break;
            default:
                break;
        }
        return result;
    };

    changeSunat(number) {
        let result = '';
        switch (number) {
            case -1:
                result = "En Proceso";
                break;
            case 0:
                result = "En Espera (Conector Local)";
                break;
            case 1:
                result = "En Espera (Nube Docele)";
                break;
            case 2:
                result = "Rechazado";
                break;
            case 3:
                result = "Aceptado con Observaciones";
                break;
            case 4:
                result = "Aceptado";
                break;
            default:
                result = " ";
                break;
        }
        return result;
    };

    openOrder = async docEntry => {
        const {enableSpinner, notificationReducer: {showAlert}} = this.props;
        enableSpinner(true);
        let response = await apiClient.getDataCreditNotes(docEntry);
        enableSpinner(false);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                order: response.data,
            });

            $('#creditNotesModal').modal('show');
            return;
        }

        showAlert({type: 'error', message: "Aviso: "+response.message})
    };

    render() {
        const {order} = this.state;
        const { orders,getData,handleInputDateInicio, handleInputDateFinal, fechaFinal,fechaInicio}  = this.props;

        return (
            <div className="content-fluid">
                <CreditNotesDetailsModal order={order}/>
                <div className="row text-center" style={{marginBottom: 16, marginTop: 16}}>
                    <div className="col-md-12">
                        <h3>Notas de crédito</h3>
                    </div>
                </div>
                <div className="row text-center" style={{marginBottom: 16, marginTop: 16}}>
                    <div className=" row col-md-4">
                        <h4 className="pr-2">Desde:</h4>
                        <input 
                            id="fechaInicio"
                            type="date" 
                            className="form-control col-md-6" 
                            name="fechauno" 
                            value = {fechaInicio}
                            onChange = {(event) => handleInputDateInicio(event)}/>
                    </div>
                    <div className="row col-md-4 pb-3">
                        <h4 className="pr-2">Hasta:</h4>
                        <input 
                            id="FechaFin"
                            type="date" 
                            className="form-control col-md-6" 
                            name="fechados" 
                            value = {fechaFinal}
                            onChange = {(event) => handleInputDateFinal(event)}/>
                    </div>
                    <div className="col-md-2 pb-2">
                        <button
                            onClick={()=>getData(6)}
                            className="btn botonResumen" 
                            style={{
                                backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                color: config.navBar.textColorCategorieHover,
                                fontWeight: "bold",
                            }}>
                            Ver resumen
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 table-responsive">
                        <table id="tablaCreditNotes" class="table table-striped">
                            <thead>
                                <tr style={{backgroundColor: config.shoppingList.summaryList, color: "white"}}>
                                    <th scope="col">No. de documento</th>
                                    <th scope="col">No. Sunat</th>
                                    <th scope="col">Fecha de contabilización</th>
                                    <th scope="col">Fecha de vencimiento</th>
                                    <th scope="col">Total peso neto</th>
                                    <th scope="col">Total peso bruto</th>
                                    <th scope="col">Cant. de articulos</th>
                                    <th scope="col">Cant. de unidades</th>
                                    <th scope="col">Valor total</th>
                                    <th scope="col">Estado SUNAT</th>
                                    <th scope="col">Estado</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((order, index) => {
                                    return (<tr key={index} style={{color: order.CANCELED === 'Y' ? 'red' : 'black'}}>
                                        <th scope="row">{order.DocNum}</th>
                                        <th scope="row">{order.NumAtCard}</th>
                                        <td>{moment(order.DocDate).format('DD-MM-YYYY')}</td>
                                        <td>{moment(order.DocDueDate).format('DD-MM-YYYY')}</td>
                                        <td>{order.Weight1 === null ? '0 KG' : parseFloat(order.Weight1).toFixed(2)+ ' KG'}</td>
                                        <td>{order.Weight2 === null ? '0 KG' : parseFloat(order.Weight2).toFixed(2)+ ' KG'}</td>
                                        <td>{parseInt(order.Cant)}</td>
                                        <td>{parseInt(order.Unit)}</td>
                                        <td className="text-right">
                                            <CurrencyFormat 
                                                value={order.DocTotal} 
                                                displayType={'text'} 
                                                thousandSeparator={true} 
                                                fixedDecimalScale={true} 
                                                decimalScale={2} 
                                                prefix={config.general.currency}>
                                            </CurrencyFormat>
                                        </td>
                                        <td className="text-center">{this.changeSunat(order.U_SYP_FEESUNAT)}</td>
                                        <td>{this.docChangeName(order.DocStatus)}</td>
                                        <td>
                                            <sapn onClick={() => this.openOrder(order.DocEntry)}>
                                                <i className={config.icons.detail} style={{color: config.shoppingList.summaryList, paddingRight: 6}}></i>
                                                Detalle
                                            </sapn>
                                        </td>
                                    </tr>)
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(creditNotesView);